import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { useSidebarItems } from './SidebarItems';
import Breadcrumbs from '@mui/joy/Breadcrumbs';
import Link from '@mui/joy/Link';
import Typography from '@mui/joy/Typography';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';

const findItemByPath = (items: any[], path: string): any => {
  for (const item of items) {
    if (item.path === path) return item;
  }
  return null;
};

export default function BreadcrumbsComponent() {
  const location = useLocation();
  const sidebarItems = useSidebarItems();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  const breadcrumbs = React.useMemo(() => {
    const result = [
      {
        title: '',
        path: '/',
        icon: <HomeRoundedIcon />,
      },
    ];

    let currentPath = '';
    for (const segment of pathSegments) {
      currentPath += `/${segment}`;
      const item = findItemByPath(sidebarItems, currentPath);
      if (item) {
        result.push({
          title: item.title,
          path: item.path,
          icon: item.icon,
        });
      }
    }

    return result;
  }, [location.pathname, sidebarItems]);

  return (
    <Breadcrumbs
      size="sm"
      aria-label="breadcrumbs"
      separator={<ChevronRightRoundedIcon fontSize="small" />}
      sx={{ pl: 0 }}
    >
      {breadcrumbs.map((crumb, index) => {
        const isLast = index === breadcrumbs.length - 1;
        return isLast ? (
          <Typography key={crumb.path} color="primary" sx={{ fontWeight: 500, fontSize: 12 }}>
            {crumb.title}
          </Typography>
        ) : (
          <Link
            key={crumb.path}
            underline="hover"
            color="neutral"
            href={crumb.path}
            sx={{ fontSize: 12, fontWeight: 500 }}
          >
            {index === 0 ? crumb.icon : crumb.title}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
}
